// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__2w8W6","Label":"BuildControl_Label__14Z0p","Less":"BuildControl_Less__2yb4l","More":"BuildControl_More__2A_d3"};